import { z } from "zod";

export interface AddressDetails {
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  zipcode?: string | null;
  apn?: string | null;
}

export interface ValidAddressDetails extends AddressDetails {
  address1: string;
  city: string;
  state: string;
  zipcode: string;
}

export const AddressSchema = z.object({
  address1: z.string().min(1, "Address is required"),
  address2: z.string(),
  city: z.string().min(1, "City is required"),
  state: z.string().length(2, "State must be 2 characters"),
  zipcode: z
    .string()
    .regex(/^\d{5}(-\d{4})?$/, "Please enter a valid ZIP code"),
  apn: z.string().optional(),
});

/** Property add-address form always includes APN (empty string if unknown). */
export const PropertyAddressSchema = AddressSchema.extend({
  apn: z.string(),
});

export type AddressDetailsFormData = z.infer<typeof PropertyAddressSchema>;
